import { useTranslation } from 'react-i18next';
import { StackedRibbonListMinimal, StackedRibbonListWrapper } from '@tanium/react-stacked-ribbon-list';

export const IdentityProviderGroupDescription = () => {
  const { t } = useTranslation();

  const columns = [
    {
      label: t('User Role'),
      dataKey: 'userRole',
      primary: true,
      width: 150,
    },
    {
      label: t('Description'),
      dataKey: 'description',
    },
  ];

  const data = [
    {
      id: 1,
      userRole: t('User'),
      description: t('The User role is used for users who do not match an identity provider role.'),
    },
  ];

  const dataGetter = (i: number) => data[i];

  return (
    <StackedRibbonListWrapper height="65px">
      <StackedRibbonListMinimal
        columns={columns}
        isItemLoaded={() => true}
        itemCount={data.length}
        dataGetter={dataGetter}
        itemIdGetter={(i) => dataGetter(i).id}
        sort={[]}
      />
    </StackedRibbonListWrapper>
  );
};
